import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TypeWriterEffect from "react-typewriter-effect";
import "./Skills.css";

const Skills = () => {
  return (
    <div className="skill-section my-5 pb-5">
      <Container className="py-5 my-5">
        <h1
          className="py-5 mb-5"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.624)" }}
        >
          <TypeWriterEffect
            textStyle={{
              textAlign: "center",
            }}
            startDelay={100}
            cursorColor="transparent"
            text="SKILLS"
            typeSpeed={100}
            // scrollArea={myAppRef}
          />
        </h1>

        <Row className="g-4 justify-content-center">
          <Col xs={6} md={6} lg={2}>
            <div className="each-skill">
              <img
                className="w-50"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg"
                alt=""
              />
              <h5>HTML 5</h5>
            </div>
          </Col>
          <Col xs={6} md={6} lg={2}>
            <div className="each-skill">
              <img
                className="w-50"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg"
                alt=""
              />
              <h5>CSS 3</h5>
            </div>
          </Col>
          <Col xs={6} md={6} lg={2}>
            <div className="each-skill">
              <img
                className="w-50"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
                alt=""
              />
              <h5>JAVASCRIPT</h5>
            </div>
          </Col>
          <Col xs={6} md={6} lg={2}>
            <div className="each-skill">
              <img
                className="w-50"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"
                alt=""
              />
              <h5>REACT</h5>
            </div>
          </Col>
          <Col xs={6} md={6} lg={2}>
            <div className="each-skill">
              <img
                className="w-50"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg"
                alt=""
              />
              <h5>BOOTSTRAP</h5>
            </div>
          </Col>
          <Col xs={6} md={6} lg={2}>
            <div className="each-skill">
              <img
                className="w-50"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg"
                alt=""
              />
              <h5>NODE JS</h5>
            </div>
          </Col>
          <Col xs={6} md={6} lg={2}>
            <div className="each-skill">
              <img
                className="w-50"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg"
                alt=""
              />
              <h5>MONGODB</h5>
            </div>
          </Col>
          <Col xs={6} md={6} lg={2}>
            <div className="each-skill">
              <img
                className="w-50"
                src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg"
                alt=""
              />
              <h5>FIREBASE</h5>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Skills;
